import { FormControl } from "@angular/forms";
import { messages } from "../resources/messages";

export const iccidRegex = /^[0-9]{0,22}$/; // NOSONAR
export const iccidValid = (control: FormControl) => (iccidRegex.test(control.value || 0) ? null : { iccid: messages.validation.iccid });
